// 请求拦截、响应拦截、错误统一处理
import Vue from "vue";
import axios from "axios";
import router from "../router";
import store from "../store/index";
import { Toast } from "vant";

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true,
  });
};
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  //   console.log("toLogin", router.currentRoute.name);
  if (router.currentRoute.name === "login") return;
  router.replace({
    path: "/login",
    query: {
      redirect: router.currentRoute.fullPath,
    },
  });
};

/**
 * 请求失败后的错误统一处理
 * @param {Number} code 请求失败的状态码
 */
const errorHandle = (code, other) => {
  // 状态码判断
  switch (code) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      tip("无权访问");
      localStorage.removeItem("token");
      store.commit("loginSuccess", null);
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    // 404请求不存在
    case 404:
      toLogin();
      break;
    default:
      console.log(other);
  }
};

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle2 = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      tip("Срок действия входа истек, пожалуйста, войдите снова");
      localStorage.removeItem("token");
      store.commit("loginSuccess", null);
      store.commit("$userInfo", null);
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    // 404请求不存在
    case 404:
      tip("请求的资源不存在");
      break;
    default:
      console.log(other);
  }
};

// 通过axios.create方法创建一个axios实例，用instance 接收
const instance = axios.create({
  // 指定请求的根路径
  //baseURL: 'http://www.liulongbin.top:3006',
  timeout: 1000 * 12,
});
// 环境的切换
// if (process.env.NODE_ENV == "development") {
//   instance.defaults.baseURL = "https://www.baidu.com";
// } else if (process.env.NODE_ENV == "debug") {
//   instance.defaults.baseURL = "https://www.ceshi.com";
// } else if (process.env.NODE_ENV == "production") {
//   instance.defaults.baseURL = "https://www.production.com";
// }
// 设置post请求头
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    token && (config.headers.token = token);
    if (config.params) {
      config.params.lang = "ru";
    } else {
      config.params = {
        lang: "ru",
      };
    }
    console.log(config);
    return config;
  },
  (error) => Promise.error(error)
);
// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  (res) => {
    if (res.data.code != 1) {
      console.log(res);
      errorHandle(res.data.code, res.data.msg);
    }
    return Promise.resolve(res.data);
  },
  // 请求失败
  (error) => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle2(response.status, response.data.msg);
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      if (!window.navigator.onLine) {
        store.commit("changeNetwork", false);
      } else {
        return Promise.reject(error);
      }
    }
  }
);

Vue.prototype.$http = instance;
